import { Map } from 'immutable';
import { moment } from 'utils';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function appointmentsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state
        .set('loading', true)
        .set('data', null)
        .set('deleteLoading', false)
        .set('error', null)
        .set('cancelError', null);
    case actionTypes.REQUEST_SUCCESS:
      return state.set('loading', false).set('data', mapAppointments(state, action.payload));
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    case actionTypes.CANCEL_REQUEST_START:
      return state.set('cancelLoading', true).set('cancelError', null).set('cancelSuccess', false);
    case actionTypes.CANCEL_REQUEST_SUCCESS:
      return state
        .set('cancelLoading', false)
        .set('cancelSuccess', true)
        .setIn(['data', action.payload.bookId], setIsCanceled(state, action.payload));
    case actionTypes.CANCEL_REQUEST_FAILURE:
      return state.set('cancelLoading', false).set('cancelError', action.payload);
    case actionTypes.SET:
      return state.set('data', mapAppointments(state, action.payload));
    default:
      return state;
  }
}

function mapAppointments(state, payload) {
  const appointment = { [payload.bookId]: payload.data };
  const data = state.get('data');
  const appointmentMap = Map(appointment);

  return data ? data.merge(appointmentMap) : appointmentMap;
}

function setIsCanceled(state, payload) {
  const appointment = state.getIn(['data', payload.bookId]);
  return Object.assign({}, appointment, {
    isCanceled: true,
    cancelDate: moment(),
  });
}
